import { EventInfo } from '../types';

export class Track {
  isReact = true;

  isPC = false;

  /**
   * Creates an instance of Track.
   * @param {{ isReact: boolean, isPC: boolean }}
   * @memberof Track
   */
  constructor({ isReact, isPC }: { isReact: boolean, isPC: boolean }) {
    if (typeof isReact !== 'undefined') {
      this.isReact = isReact;
    }
    if (typeof isPC !== 'undefined') {
      this.isPC = isPC;
    }
  }

  /**
   * 构造埋点数据
   *
   * @protected
   * @param {EventInfo} info
   * @returns {EventData}
   * @memberof Track
   */
  _generateEventData(info: EventInfo) {
    return {
      type: 'v3',
      timestamp: Date.now(),
      info: { ...info },
      source: this.isPC ? 'pc' : this.isReact ? 'rweb' : 'mweb',
    };
  }
}
